'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _reactReduxForm = require('react-redux-form');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _simpleGrayLayout = require('common/components/simple-gray-layout');

var _simpleGrayLayout2 = _interopRequireDefault(_simpleGrayLayout);

var _signUpForm = require('hellosign/components/auth/sign-up-form');

var _signUpForm2 = _interopRequireDefault(_signUpForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Top-level component for standalone Sign Up page.
 * Expects some props from the backend, such as CSRF token.
 */
var SignUpPage = function (_React$Component) {
    _inherits(SignUpPage, _React$Component);

    function SignUpPage(props) {
        _classCallCheck(this, SignUpPage);

        var _this = _possibleConstructorReturn(this, (SignUpPage.__proto__ || Object.getPrototypeOf(SignUpPage)).call(this, props));

        var initialState = {
            email: _this.props.emailAddress,
            marketingOptIn: !(_this.props.marketingOptIn === false),
            csrfToken: _this.props.csrfToken,
            redirectUrl: _this.props.redirectUrl,
            pendingTsmGroupGuid: _this.props.pendingTsmGroupGuid
        };

        // This is a hack for OAuth flows and ensures that we redirect
        // back to the referrer when the user signs up. This fixes an issue
        // where new users would be taken out of the OAuth flow when attempting
        // to create a new account (DEV-2687)
        var ref = document.referrer;
        if (ref.indexOf('oauth') > 0) {
            initialState.redirectUrl = ref;
        }

        _this.store = (0, _redux.createStore)((0, _reactReduxForm.combineForms)({
            signUp: initialState
        }), (0, _redux.applyMiddleware)(_reduxThunk2['default']));
        return _this;
    }

    _createClass(SignUpPage, [{
        key: 'render',
        value: function render() {
            return _react2['default'].createElement(
                _reactRedux.Provider,
                { store: this.store },
                _react2['default'].createElement(
                    _simpleGrayLayout2['default'],
                    null,
                    _react2['default'].createElement(_signUpForm2['default'], this.props)
                )
            );
        }
    }]);

    return SignUpPage;
}(_react2['default'].Component);

SignUpPage.propTypes = {
    // CSRF Token - Sent from the server
    csrfToken: _react2['default'].PropTypes.string.isRequired,

    // Email value - This is useful to provide for testing purposes
    emailAddress: _react2['default'].PropTypes.string,

    marketingOptIn: _react2['default'].PropTypes.bool,
    redirectUrl: _react2['default'].PropTypes.string,
    pendingTsmGroupGuid: _react2['default'].PropTypes.string
};


module.exports = SignUpPage;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/sign-up-page.jsx
 ** module id = 887
 ** module chunks = 0
 **/